import classNames from 'classnames/bind';
import styles from './Search.module.css';
import { FormEvent, useState } from 'react';
import { SEARCH, SEARCH_INPUT_PLACEHOLDER } from '../../constants';
import { TooltipWrapper } from '../Tooltip';

interface Search {
  name?: string;
  onSubmit: (keyword: string) => void;
  isBgWhite?: boolean;
}

export default function Search({ name, onSubmit, isBgWhite }: Search) {
  const cx = classNames.bind(styles);
  const [isShowInput, setIsShowInput] = useState(false);
  const [keyword, setKeyword] = useState('');

  const cancelSearch = () => {
    setKeyword('');
    setIsShowInput(false);
    onSubmit('');
  };

  const submitKeyword = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSubmit(keyword);
  };

  const clickSearchIcon = (e: React.MouseEvent) => {
    if (!isShowInput) {
      e.preventDefault();
      setIsShowInput(true);
    }
  };

  return (
    <div
      className={cx(
        'option_search',
        { rt48: name === 'activity-student' },
        { active: isShowInput }
      )}
    >
      <form role="search" onSubmit={submitKeyword}>
        {isShowInput && (
          <label>
            <div className={cx('search_area', { bg_w: isBgWhite })}>
              <span className={cx('blind')}></span>
              <input
                type="text"
                placeholder={SEARCH_INPUT_PLACEHOLDER}
                onChange={({ target }) => setKeyword(target.value)}
              />
              <button
                type="button"
                className={cx('btn', 'ico_cancel')}
                onClick={cancelSearch}
              >
                <span className={cx('blind')}></span>
              </button>
            </div>
          </label>
        )}

        <TooltipWrapper content={SEARCH} onClick={clickSearchIcon}>
          {(tooltipProps) => (
            <button
              className={cx('btn', 'ico_search', { active: isShowInput })}
              {...tooltipProps}
            >
              <span className={cx('blind')}>{SEARCH}</span>
            </button>
          )}
        </TooltipWrapper>
      </form>
    </div>
  );
}
